package uz.ferro.shop.pages.about

import kotlinx.serialization.Serializable

@Serializable
data class AboutPageData(
    val aboutUS: PageContentItem,
    val statistics: PageContentItem,
    val mission: PageContentItem,
    val strategy: PageContentItem,
    val companyValues: PageContentItem,
    val achievements: PageContentItem,
    val structure: PageContentItem,
    val whsAndDist: PageContentItem,
    val productRange: PageContentItem,
    val flagsSection: PageContentItem,
    val whyChoose: PageContentItem,
    val stores: PageContentItem,
    val whereFind: PageContentItem
)
